"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrinterStruct = exports.PrintJobStruct = exports.PrinterConfigStruct = exports.EpsonSdpPrinterConfigStruct = exports.PrinterDriverStruct = exports.PrinterStatusStruct = void 0;
const superstruct_1 = require("superstruct");
const utils_1 = require("../utils");
exports.PrinterStatusStruct = (0, superstruct_1.enums)(['active', 'inactive', 'pending']);
exports.PrinterDriverStruct = (0, superstruct_1.enums)(['epson-connect', 'epson-poskey', 'epson-sdp']);
/**
 * Driver-specific config for Epson Server Direct Print (pull model).
 */
exports.EpsonSdpPrinterConfigStruct = (0, superstruct_1.object)({
    printerCode: (0, superstruct_1.string)(),
    token: (0, superstruct_1.string)(),
    pullIntervalSeconds: (0, superstruct_1.number)(),
    /** Device ID of the TM printer registered in the SDP module's WebConfig (default: "local_printer") */
    externalDeviceId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    connectedAt: utils_1.TimestampStruct,
    lastPullAt: (0, superstruct_1.optional)(utils_1.TimestampStruct),
});
exports.EpsonSdpPrinterConfigStruct.type = 'EpsonSdpPrinterConfig';
/**
 * Driver-namespaced config map stored on the printer document.
 * Each key corresponds to a driver; only the relevant key is populated.
 */
exports.PrinterConfigStruct = (0, superstruct_1.object)({
    'epson-sdp': (0, superstruct_1.optional)(exports.EpsonSdpPrinterConfigStruct),
});
exports.PrinterConfigStruct.type = 'PrinterConfig';
/**
 * A pending print job stored directly on the printer document.
 * Only the last job is retained (overwrites on new job creation).
 */
exports.PrintJobStruct = (0, superstruct_1.object)({
    content: (0, superstruct_1.string)(),
    format: (0, superstruct_1.enums)(['text', 'escpos', 'epos-xml']),
    createdAt: utils_1.TimestampStruct,
    sourceId: (0, superstruct_1.string)(),
});
exports.PrintJobStruct.type = 'PrintJob';
exports.PrinterStruct = (0, superstruct_1.object)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.string)(),
    driver: (0, superstruct_1.optional)(exports.PrinterDriverStruct),
    config: (0, superstruct_1.optional)(exports.PrinterConfigStruct),
    pendingJob: (0, superstruct_1.optional)(exports.PrintJobStruct),
    model: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    status: exports.PrinterStatusStruct,
    createdAt: utils_1.TimestampStruct,
    updatedAt: utils_1.TimestampStruct,
});
exports.PrinterStruct.type = 'Printer';
//# sourceMappingURL=printer.js.map